// components/industry-templates/HREventTemplate.tsx
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Users, Briefcase, TrendingUp, Award } from 'lucide-react';

export const HREventTemplate = ({ structure, theme }: any) => {
  const industryData = structure.industry_data;

  return (
    <div className="space-y-8">
      {/* HR Tech Solutions */}
      {industryData?.hr_tech && (
        <Card className="border-0 bg-gradient-to-br from-blue-500/20 to-cyan-500/20 backdrop-blur">
          <CardHeader>
            <CardTitle className="text-white flex items-center gap-2 text-2xl">
              <Users className="w-8 h-8" style={{ color: theme.primary }} />
              HR Technology Solutions
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="grid grid-cols-2 gap-4">
              {industryData.hr_tech.map((tech: any, idx: number) => (
                <div key={idx} className="p-5 bg-white/10 rounded-xl">
                  <h3 className="text-xl font-bold text-white mb-2">{tech.name}</h3>
                  <p className="text-slate-300 text-sm mb-3">{tech.description}</p>
                  <Badge style={{ backgroundColor: theme.primary }}>{tech.category}</Badge>
                </div>
              ))}
            </div>
          </CardContent>
        </Card>
      )}

      {/* Talent Management */}
      {industryData?.talent_sessions && (
        <Card className="border border-white/10 bg-slate-900/50 backdrop-blur">
          <CardHeader>
            <CardTitle className="text-white flex items-center gap-2">
              <Briefcase className="w-6 h-6" style={{ color: theme.primary }} />
              Talent Management Sessions
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="space-y-3">
              {industryData.talent_sessions.map((session: any, idx: number) => (
                <div key={idx} className="p-4 bg-white/5 rounded-lg border-l-4" style={{ borderColor: theme.primary }}>
                  <h4 className="font-bold text-white">{session.topic}</h4>
                  <p className="text-sm text-slate-400">{session.speaker}</p>
                </div>
              ))}
            </div>
          </CardContent>
        </Card>
      )}
    </div>
  );
};
